import {
  MULTI_CHARACTER_DEPTH_OFFSET,
  MULTI_CHARACTER_SLOT_SPACING
} from '../constants/simulationConstants';

export const DEFAULT_CHARACTER_EMOTION = {
  emotion: 'neutral',
  intensity: '1'
};

/**
 * True for a well-formed multi-character initialize payload: the explicit
 * flag, and one bot id per character id.
 */
export function isMultiCharacterPayload(payload) {
  const botIds = payload?.botIds;
  const characterIds = payload?.characterIds;

  return (
    payload?.isMultiCharacter === true &&
    Array.isArray(botIds) &&
    Array.isArray(characterIds) &&
    botIds.length > 0 &&
    botIds.length === characterIds.length &&
    botIds.every((botId) => typeof botId === 'string' && botId.trim())
  );
}

/** Pairs each avatar with the bot that speaks through it, by index. */
export function pairCharacterIdsWithBotIds(characterIds = [], botIds = []) {
  return characterIds.map((characterId, index) => ({
    characterId,
    botId: botIds[index] ?? null
  }));
}

/** Bot ids the parent sent that the agent session does not list as members. */
export function findMissingBotIds(expectedBotIds = [], sessionAgents = []) {
  const sessionBotIds = new Set(
    (sessionAgents ?? []).map((agent) => agent?.bot_id).filter(Boolean)
  );

  return expectedBotIds.filter((botId) => !sessionBotIds.has(botId));
}

/** Spreads avatars evenly around the centre of the scene, set back in depth. */
export function getMultiCharacterPosition(index, count) {
  if (count <= 1) return [0, 0, 0];

  const offset = (index - (count - 1) / 2) * MULTI_CHARACTER_SLOT_SPACING;
  return [offset, 0, MULTI_CHARACTER_DEPTH_OFFSET];
}

/**
 * The client one avatar sees. Every avatar shares the audio element, but only
 * the one whose chunk is playing talks and lip-syncs; each keeps its own
 * emotion.
 */
export function buildCharacterClient({
  client,
  botId,
  talkingBotId,
  emotionsByBotId = {}
}) {
  const isSpeaking = Boolean(botId) && talkingBotId === botId;

  return {
    ...client,
    isTalking: Boolean(client?.isTalking) && isSpeaking,
    facialData: isSpeaking ? (client?.facialData ?? []) : [],
    emotion: emotionsByBotId[botId] ?? DEFAULT_CHARACTER_EMOTION
  };
}
